import React from "react";

import translate from "./../../../lib/translate/TranslateJs";


class CTCAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }
    componentDidMount() {
        const { bankAccounts, value, setFormStaticData } = this.props;
        if (bankAccounts && bankAccounts.length) {
            const Code = value || bankAccounts[0].code;
            setFormStaticData("ctcmethod", Code);
            this.setDefaultCode(Code);
        }
    }
    componentDidUpdate(prevProps) {
        // 设置第一次进入充值的默认Code
        const { bankAccounts, value } = this.props;
        if (
            Array.isArray(bankAccounts) &&
            bankAccounts.length &&
            (
                // 简易优化深度对比
                typeof prevProps.bankAccounts !== typeof bankAccounts ||
                prevProps.bankAccounts.length !== bankAccounts.length ||
                JSON.stringify(prevProps.bankAccounts) !== JSON.stringify(bankAccounts)
            )
        ) {
            const Code = Array.isArray(bankAccounts) && bankAccounts.length ?
                (value || bankAccounts[0].code)
                    : "";

            this.props.setCurrFormData({ "ctcmethod": Code });
            this.setDefaultCode(Code);
        }
    }
    setDefaultCode = (code) => {
        typeof this.props.changeType === "function" && this.props.changeType(code);
    }
    // getCTCName = (v) => {
    //     let ctcName = "";

    //     this.props.bankAccounts.some((ctcItem) => {
    //         if (ctcItem.code === v) {
    //             ctcName = ctcItem.code;
    //             return true;
    //         }
    //     });

    //     return ctcName;
    // }
    render() {

        const { Item, CTCRadio, Input } = this.props;
        const { label, bankAccounts, notRequired } = this.props;

        return Array.isArray(bankAccounts) && bankAccounts.length > 0 && !!bankAccounts[0].code ? 
            <Item
                fieldName="ctcmethod"
                label={label || translate("支付币种")()}
                rules={[{
                    required: true,
                    message: translate("请选择支付币种")()
                }]}
            >
                {(control) => {
                    return <CTCRadio
                        bankAccounts={bankAccounts}
                        // currName={this.getCTCName(control.value)}
                        currValue={control.value}
                        onSelectChange={(v) => {
                            this.setDefaultCode(v);
                            control.onChange(v);
                        }}
                    />
                }}
            </Item> : (notRequired ? null : <Item
                fieldName="ctcmethod_other"
                label={label || translate("支付币种")()}
                rules={[{
                    required: true,
                    message: translate("请联系客服添加加密货币信息")()
                }]}
            >
                {() => <Input value={translate("请联系客服添加加密货币信息")()} disabled />}
            </Item>)
    }
}

export default CTCAccount
